import { ErrorMessage } from 'formik';
import React from 'react';
import { FormErrorMessage } from '../../../../base-components/FormErrorMessage';
import { FormRadioButton } from '../../../../base-components/FormRadioButton';
import styles from './Role.module.scss';

export const Role = () => {
    return (
        <div className={styles.container}>
            <div className={styles.title}>Я хочу зарегистрироваться как:</div>
            <div
                role="group"
                aria-labelledby="my-radio-group"
                className={styles.radioGroup}
            >
                <FormRadioButton
                    name="organization.role"
                    value="customer"
                    className={styles.radio}
                >
                    Заказчик
                </FormRadioButton>

                <FormRadioButton
                    name="organization.role"
                    value="participant"
                    className={styles.radio}
                >
                    Участник
                </FormRadioButton>

                <FormErrorMessage name="organization.role" />
            </div>
        </div>
    );
};
